import { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import Audi from "images/audi.png";
import BMW from "images/BMW.png";
import Ford from "images/Ford.png";
import Peugeot from "images/Peuget.png";
import volkswagon from "images/Volkswagon.png";

const brands = [
    { name: "Audi", logo: Audi },
    { name: "BMW", logo: BMW },
    { name: "Ford", logo: Ford },
    { name: "Peugeot", logo: Peugeot },
    { name: "Volkswagen", logo: volkswagon },
];

const BrowseByBrands = () => {
    const [visibleStartIndex, setVisibleStartIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);

    const handleResize = () => {
        if (window.innerWidth >= 1280) {
            setItemsPerPage(5); // xl
        } else if (window.innerWidth >= 1024) {
            setItemsPerPage(4); // lg
        } else if (window.innerWidth >= 768) {
            setItemsPerPage(3); // md
        } else {
            setItemsPerPage(2); // sm
        }
    };

    useEffect(() => {
        handleResize(); // Set initial items per page
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleNext = () => {
        if (visibleStartIndex + itemsPerPage < brands.length) {
            setVisibleStartIndex(visibleStartIndex + itemsPerPage);
        }
    };

    const handlePrevious = () => {
        if (visibleStartIndex - itemsPerPage >= 0) {
            setVisibleStartIndex(visibleStartIndex - itemsPerPage);
        }
    };

    return (
        <>
            <div className="flex items-center w-full">
                <div className="flex justify-center items-center w-full ">
                    <h2 className="text-2xl font-semibold text-gray-800">Browse By Brands</h2>
                </div>
            </div>
            <div className="flex flex-row justify-end space-x-2 !mt-2 pr-4">
                <button
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 ${visibleStartIndex === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                    aria-label="Previous"
                    onClick={handlePrevious}
                    disabled={visibleStartIndex === 0}
                >
                    <ChevronLeftIcon className="w-6 h-6 text-red-500" />
                </button>
                <button
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 ${visibleStartIndex + itemsPerPage >= brands.length ? 'opacity-50 cursor-not-allowed' : ''}`}
                    aria-label="Next"
                    onClick={handleNext}
                    disabled={visibleStartIndex + itemsPerPage >= brands.length}
                >
                    <ChevronRightIcon className="w-6 h-6 text-red-500" />
                </button>
            </div>
            <div className="flex justify-center !mt-12">
                <div className={`grid gap-12 `} style={{ gridTemplateColumns: `repeat(${itemsPerPage}, minmax(0, 1fr))` }}>
                    {brands.slice(visibleStartIndex, visibleStartIndex + itemsPerPage).map((brand, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow hover:shadow-md transition min-w-[150px] md:min-w-[200px]"
                        >
                            <img
                                src={brand.logo}
                                alt={`${brand.name} logo`}
                                className="w-16 h-16 mb-2"
                            />
                            <span className="text-gray-700 font-medium">{brand.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default BrowseByBrands;
